import getCache from '../../cache/helpers/getCache';

export default () => {
  const { isRealtimeOffline } = getCache('app')?.data;
  return isRealtimeOffline || false;
};
